import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BaseGetProvider } from "@tendercuts/http";
import { BookingRequest } from "@tendercuts/models";

@Injectable({
  providedIn: "root",
})
export class BookingStatusService extends BaseGetProvider<BookingRequest> {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices,
  ) {
    super(http);
    this.delegate = this;
  }

  // override this
  preProcessResponse(response: any): Array<any> {
    return response.results;
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof BookingRequest {
    return BookingRequest;
  }

  get endpoint(): string {
    return this.endpointService.bookingStatus();
  }

  get isCachable(): boolean {
    return false;
  }

  getparams(
    storeId: number,
  ): {
    store_id: number;
  } {
    const param: {
      store_id: number;
    } = {
      store_id: storeId,
    };

    return param;
  }
}
